

var menuBtn = document.getElementById('clickable-icon');
menuBtn.addEventListener("click", function(){
    var mobileMenu = document.getElementsByClassName("mobile-menu")[0]
    mobileMenu.classList.toggle("hidden")
    menuBtn.classList.toggle("colorswitch")
}); 

var bodyHeight = document.body.scrollHeight
var bgHeight = document.getElementsByClassName("background")[0]
bgHeight.style.minHeight = bodyHeight + "px"

const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("in-view");
      }
    });
  });

  function applyObservers() {
    const rows = document.getElementsByClassName('anim-elements')

    if (rows != null) {
      Object.keys(rows).forEach((key) => {
        if (rows[key].classList != undefined) {
          rows[key].classList.add("observed");
        }
      });
    }

    let slidingElements = document.querySelectorAll(".observed");
    slidingElements.forEach((el) => observer.observe(el));
  }
  applyObservers();